import { render, staticRenderFns } from "./break-delete-dialog.vue?vue&type=template&id=b12ece70&scoped=true"
import script from "./break-delete-dialog.vue?vue&type=script&lang=js"
export * from "./break-delete-dialog.vue?vue&type=script&lang=js"
import style0 from "./break-delete-dialog.vue?vue&type=style&index=0&id=b12ece70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12ece70",
  null
  
)

export default component.exports